import { render, staticRenderFns } from "./ResultDetailProgram.vue?vue&type=template&id=57638a57&scoped=true&"
import script from "./ResultDetailProgram.vue?vue&type=script&lang=ts&"
export * from "./ResultDetailProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57638a57",
  null
  
)

export default component.exports